import { ODGNBTextMenu } from './menu/variants/ODGNBTextMenu'
import { ODGNBDropdownMenu } from './menu/variants/ODGNBDropdownMenu'
import React from 'react'
import { ODMenuItemType } from '../../interfaces/globalInterfaces'
var ODGNBFactory = /** @class */ (function () {
  function ODGNBFactory(def) {
    this.def = def
  }
  ODGNBFactory.prototype.renderMenuItem = function (globalKey, def, insideDropDown) {
    switch (def.type) {
      case ODMenuItemType.Text:
        return React.createElement(ODGNBTextMenu, { key: globalKey, def: def, insideDropdown: insideDropDown })
      case ODMenuItemType.Dropdown: {
        return React.createElement(ODGNBDropdownMenu, { key: globalKey, def: def })
      }
    }
  }
  return ODGNBFactory
})()
export { ODGNBFactory }
//# sourceMappingURL=ODGNBFactory.js.map
